import request from '@/router/axios';

/** 管理端：某条通知的阅读记录分页 */
export const getNoticeReadPage = (current, size, params) => {
  return request({
    url: '/api/blade-desk/notice-user/read-page',
    method: 'get',
    params: {
      current,
      size,
      ...params,
    },
  });
};
